<template>
  <v-tooltip top>
    <template v-slot:activator='{ on }'>
      <v-chip
        v-on='on'
        :small='!xSmall'
        :x-small='xSmall'
        label
        :color='type_data.color'
        dark
        :class='type_class'
      >
        <v-icon left :small='!xSmall' :xSmall='xSmall'>{{ type_data.icon }}</v-icon>
        {{ type_data.text }}
      </v-chip>
    </template>
    <span>{{ type_data.tooltip }}</span>
  </v-tooltip>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'estimate-type-chip',
  props: {
    estimate: {
      required: true
    },
    xSmall: {
      required: false,
      type: Boolean,
      default: false
    },
    left: {
      required: false,
      type: Boolean,
      default: false
    },
    right: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  computed: {
    type_class () {
      let ret = ''
      if (this.left) {
        ret += 'mr-2 '
      }
      if (this.right) {
        ret += 'ml-2 '
      }
      return ret
    },
    type_data () {
      let e = this.estimate.estimate_type
      return _.find(this.$store.state.misc.globalOptions.estimateTypeOptions, function (t) { return t.value === e })
    }
  }
}
</script>
